import { React, useState } from "react";
import { Link } from "react-scroll";
export const Navigation = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar navbar-expand p-0 mb-0 iplContestNavigation">
      <button className="d-inline-block d-md-none menuBtn" onClick={handleNav}>
        <i className="fa-solid fa-bars"></i>
        {/* <img src="./Images/iplContest/menu.png" /> */}
      </button>
      <a className="navbar-brand custom-logo" href="https://www.watcho.com/">
        <img
          src="./Images/logo.svg"
          alt="My Logo"
          className="img-fluid clas-of-logo"
        />
      </a>
      

      <div className="d-md-flex align-items-center justify-content-between flex-fill">
        <ul className={`navbar-nav mr-auto mobileMenu ${
          menuOpen ? "d-block" : "d-none d-md-block"
        }`}>
          <button className="d-block d-md-none closeMenu" onClick={() => {setMenuOpen(false)}}>
            <i className="fa-solid fa-times"></i>
          </button>
          {
            menuOpen && <div className="overlay"></div>
          }
          <li className="nav-item active">
            <Link className="nav-link" to="home" onClick={() => setMenuOpen(false)} smooth={true} duration={500}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className="nav-link"
              to="howToPlay"
              smooth={true}
              duration={500}
              onClick={() => setMenuOpen(false)}
            >
              How To Play?
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link"  onClick={() => setMenuOpen(false)} to="faq" smooth={true} duration={500}>
              FAQs
            </Link>
          </li>
        </ul>
        <div className="leaderBoardBtn">
          <Link
            className="nav-link"
            to="leaderBoards"
            smooth={true}
            duration={500}
          >
            Leaderboard
          </Link>
          {/* <a href="#">
              LeaderBoard
            </a> */}
        </div>
        {/* {menuToggle ? (
          <div className="postResult">
            <a href="#" onClick={handlePostResultModal}>
              Check Past Results
            </a>
          </div>
        ) : (
          ""
        )} */}
      </div>
    </nav>
  );
};
